<template>
  <Header />
  <!-- App Capsule -->
  <div style="padding-top: 55px;">

    <div class="login-form mt-5">
      <div class="section">
        <h1>ثبت نام راننده</h1>
        <h4>بزرگترین سامانه هوشمند اعلام بار کشور</h4>
      </div>
      <div class="section mt-2 mb-5">
        <form @submit.prevent="registerDriver">

          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="name">نام</label>
              <input type="text" @keyup="typeName" class="form-control" id="name" v-model="postData.name"
                placeholder="نام" pattern=".{3,}" required title="حداقل سه رقم فارسی">
              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>
          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="lastname">نام خانوادگی</label>
              <input type="text" class="form-control" id="lastname" v-model="postData.lastName" required>
              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>
          <div class="form-group boxed">
            <div class="input-wrapper">
              <label class="form-label" for="nationalCode">کد ملی</label>
              <input type="text" class="form-control" id="nationalCode" v-model="postData.nationalCode" min="10"
                max="10" required>
              <i class="clear-input">
                <ion-icon name="close-circle"></ion-icon>
              </i>
            </div>
          </div>


          <div class="form-group boxed" @click="backFleet()">
            <div class="input-wrapper">
              <label class="form-label fw-bold" for="to">نوع ناوگان</label>
              <span class="form-control form-select mt-1 text-start" data-bs-toggle="offcanvas"
                data-bs-target="#actionSheetForm" href="#">{{ selectedState }}</span>
            </div>
          </div>

          <div class="form-button-group">
            <button v-if="loading == false" type="submit" class="btn background-blue text-light btn-block btn-lg">
              ثبت نام
            </button>
            <button v-else class="btn background-blue text-light btn-block btn-lg" type="button" disabled>
              <span class="spinner-border spinner-border-sm me-05" role="status" aria-hidden="true"></span>
              درحال بررسی ...
            </button>
          </div>
        </form>
        <div class="offcanvas offcanvas-bottom action-sheet" tabindex="-1" id="actionSheetForm">
          <div class="offcanvas-header background-TEAL">
            <h5 class="offcanvas-title text-light">انتخاب ناوگان</h5>
            <a href="#" id="backFleet" class="offcanvas-close" style="display: none" data-bs-dismiss="offcanvas">
              <ion-icon name="close-outline"></ion-icon>
            </a>
          </div>
          <div class="offcanvas-body">
            <form>
              <div class="form-group basic mb-5">
                <div class="input-wrapper">
                  <div class="section full mt-2">
                    <div class="section-title" style="justify-content: center !important;">لطفا
                      ناوگان مورد نظر
                      خود را انتخاب کنید</div>

                    <div class="accordion" id="accordionExample1">
                      <div class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#accordion5">
                            نیسان و وانت
                          </button>
                        </h2>
                        <div id="accordion5" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                          <div class="accordion-body">
                            <div class="input-list">
                              <div class="form-check" v-for="fleet in fleets.coms5" :key="fleet.id">
                                <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                  :id="'radioList' + fleet.id" v-model="postData.fleet_id"
                                  @click="changeTitleFleet(fleet.title)">
                                <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                  }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#accordion1">
                            کامیونت
                          </button>
                        </h2>
                        <div id="accordion1" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                          <div class="accordion-body">
                            <div class="input-list">

                              <div class="form-check" v-for="fleet in fleets.coms1" :key="fleet.id">
                                <input class="form-check-input" :value="fleet.id" type="radio" name="radioList"
                                  @click="changeTitleFleet(fleet.title)" :id="'radioList' + fleet.id"
                                  v-model="postData.fleet_id">
                                <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                  }}</label>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#accordion2">
                            کامیون 6 چرخ (تک)
                          </button>
                        </h2>
                        <div id="accordion2" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                          <div class="accordion-body">
                            <div class="input-list">
                              <div class="form-check" v-for="fleet in fleets.coms2" :key="fleet.id">
                                <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                  @click="changeTitleFleet(fleet.title)" :id="'radioList' + fleet.id"
                                  v-model="postData.fleet_id">
                                <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                  }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#accordion3">
                            کامیون 10 چرخ (جفت)
                          </button>
                        </h2>
                        <div id="accordion3" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                          <div class="accordion-body">
                            <div class="input-list">
                              <div class="form-check" v-for="fleet in fleets.coms3" :key="fleet.id">
                                <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                  @click="changeTitleFleet(fleet.title)" :id="'radioList' + fleet.id"
                                  v-model="postData.fleet_id">
                                <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                  }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="accordion-item">
                        <h2 class="accordion-header">
                          <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#accordion4">
                            تریلی
                          </button>
                        </h2>
                        <div id="accordion4" class="accordion-collapse collapse" data-bs-parent="#accordionExample1">
                          <div class="accordion-body">
                            <div class="input-list">
                              <div class="form-check" v-for="fleet in fleets.coms4" :key="fleet.id">
                                <input class="form-check-input" type="radio" name="radioList" :value="fleet.id"
                                  :id="'radioList' + fleet.id" v-model="postData.fleet_id"
                                  @click="changeTitleFleet(fleet.title)">
                                <label class="form-check-label" :for="'radioList' + fleet.id">{{ fleet.title
                                  }}</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group basic" style=" position: fixed; bottom: 0;">
                <button type="button" data-bs-dismiss="offcanvas" class="btn background-blue text-light btn-block">
                  ثبت
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- * App Capsule -->
</template>

<script>
import Header from "@/components/header.vue";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  components: {
    Header
  },
  data() {
    return {
      postData: {
        mobileNumber: this.$route.params.mobileNumber,
        name: "",
        lastName: "",
        nationalCode: "",
        fleet_id: "",
      },
      fleets: {
        coms1: [],
        coms2: [],
        coms3: [],
        coms4: [],
        coms5: [],
      },
      selectedState: 'انتخاب کنید',

      results: [],
      loading: false,
    };
  },
  methods: {
    backFleet() {
      if (history.pushState) {
        var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?backFleet=1';
        window.history.pushState({ path: newurl }, '', newurl);
      }
    },
    getFleets() {
      axios.get("https://xpanel.s-bar.ir/api/requestAllFleetsLists")
        .then((response) => {
          this.fleets.coms1 = response.data.data.filter(obj => obj.parent_id == 42); 
          this.fleets.coms2 = response.data.data.filter(obj => obj.parent_id == 43);
          this.fleets.coms3 = response.data.data.filter(obj => obj.parent_id == 53);
          this.fleets.coms4 = response.data.data.filter(obj => obj.parent_id == 54);
          this.fleets.coms5 = response.data.data.filter(obj => obj.parent_id == 81);
        });
    },
    typeName(event) {
      var persian = /^[\u0622\u0627\u0628\u067E\u062A-\u062C\u0686\u062D-\u0632\u0698\u0633-\u063A\u0641\u0642\u06A9\u06AF\u0644-\u0648\u06CC]+$/;
      var number = /[ ]/;
      var regex = new RegExp("(" + persian.source + ")|(" + number.source + ")")

      if (!regex.test(event.currentTarget.value)) {
        this.postData.name = '';
      }
    },
    changeTitleFleet(value) {
      this.selectedState = value;
    },
    registerDriver() {
      this.loading = true;
      axios.post("https://xpanel.s-bar.ir/api/driver/register", this.postData)
        .then((response) => {
          this.loading = false;
          if (response.data.status == 'error') {
            alert(response.data.data.message);
          } else {
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem('idUser', response.data.data.idUser)
            window.location.href = "/";
          }
        }).catch((response) => {
          this.loading = false;
          // handle error
          Swal.fire({
            position: "center",
            icon: "error",
            title: response.response.data.message,
            showConfirmButton: true,
            confirmButtonText: "تایید",
          });
        });
    },
  },
  mounted() {
    this.getFleets();
  },
};
</script>
<style></style>